import './LeitorQr.css'
import React, { useState, useEffect, useRef } from "react";
import { Button } from "reactstrap";
import {
    BrowserMultiFormatReader,
    NotFoundException,
    ChecksumException,
    FormatException,
    DecodeHintType,
    BarcodeFormat
} from "@zxing/library";



const LeitorQr = (props) => {
    const videoRef = useRef(null);
    const [selectedDeviceId, setSelectedDeviceId] = useState("");
    const [videoInputDevices, setVideoInputDevices] = useState([]);
    const [sourceSelect, setSourceSelect] = useState([]);
    const [cameraConfig, setCameraConfig] = useState(false);
    const [scanning, setScanning] = useState(true);
    const hints = new Map();
    const formats = [
        BarcodeFormat.CODE_128,
        BarcodeFormat.DATA_MATRIX,
        BarcodeFormat.QR_CODE
    ];
    hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
    hints.set(DecodeHintType.TRY_HARDER, true);
    const codeReader = new BrowserMultiFormatReader(hints, 5000);
    const leituras = [];

    console.log("ZXing code reader initialized");

    useEffect(() => {
        codeReader
            .getVideoInputDevices()
            .then((videoInputDevices) => {
                setupDevices(videoInputDevices);
            })
            .catch((err) => {
                //window.location.reload();
                console.error(err);
            });
    }, []);

    function setupDevices(videoInputDevices) {
        setSourceSelect(document.getElementById("sourceSelect"));

        // selects first device
        setSelectedDeviceId(videoInputDevices[0].deviceId);

        // setup devices dropdown
        if (videoInputDevices.length >= 1) {
            setVideoInputDevices(videoInputDevices);
        }
    }

    const decodeContinuously = (selectedDeviceId) => {
        //codeReader.timeBetweenDecodingAttempts = 2;
        codeReader.decodeFromInputVideoDeviceContinuously(
                selectedDeviceId,
                "video",
                (result, err) => {
                    if (result) {
                        props.putLeituraQr(result.text);
                        codeReader.stop();
                        //return;
                    }
                    if (err) {
                    }
        });
    }

    const manageUniqueResponse = (leituraText) => {
        leituras.push(leituraText);
        if (leituras.length > 1) {
            props.putLeituraQr(leituraText);
        }
        return;
    }


    useEffect(() => {
        decodeContinuously(selectedDeviceId);
        console.log(`Started decode from camera with id ${selectedDeviceId}`);
    }, []);

    return (
        <div class="wrapper">
            <h2 className="titulosPaginas">Leitor de Acesso</h2>
            <h3 className="cameraModeTitle">{props.cameraMode === 'SAIDA' ? 'SAÍDA' : 'ENTRADA'}</h3>
            <div className="posicaoLeitor">
                <div class="botoesLeituraPosicao" >
                <Button type="button" className="cameraModeButton" onClick={() => {
                    props.putCameramode('ENTRADA');
                }}>
                ENTRADA
            </Button>
                <Button type="button" className="cameraModeButton" onClick={() => {
                props.putCameramode('SAIDA');
            }}>
               SAÍDA
                    </Button>

            </div>
            {scanning && (<section className="container" id="demo-content">
                    {cameraConfig && <div id="sourceSelectPanel">

                        <label for="sourceSelect" className="QrCameraText" >CAMERA: </label>
                        <select
                            id="sourceSelect"
                            onChange={() => setSelectedDeviceId(sourceSelect.value)}
                        >
                            {videoInputDevices.map((element) => (
                                <option value={element.deviceId}>{element.label}</option>
                            ))}
                        </select>
                    </div>}

                <div>
                    <video id="video" width="320px" />
                </div>
                </section>)}
                <Button type="button" className="cameraModeButton" onClick={() => {
                    setCameraConfig(!cameraConfig)
                }}>
                    MODO CAMERA
                </Button>
            </div>
        </div>
    );
}

export default LeitorQr